import modalResizeUtils from '@/plugins/tm@modal/_utils/modal-resize.utils';

export default {
  data() {
    return {
      modalWidth: undefined, // Should be set by component
      modalHeight: undefined, // Should be set by component
      modalName: '', // Should be set by component
      modalSize: 'medium' as 'small' | 'medium' | 'large', // Size preset: small, medium, or large
    };
  },

  computed: {
    modalWidthPx() {
      return this.modalWidth;
    },
    modalHeightPx() {
      return this.modalHeight;
    },
  },

  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('resize', this.handleWindowResize);
    this.initModalSize();
  },

  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('resize', this.handleWindowResize);
  },

  methods: {
    handleKeyDown(event) {
      // if (event.keyCode === 27) this.closeModal()
      if (event.keyCode === 27) this.visible = false;
    },

    /**
     * Initialize modal size from localStorage or defaults
     */
    initModalSize() {
      if (!this.modalName) {
        console.warn('Modal name not set for resize functionality');
        return;
      }

      const size = modalResizeUtils.getModalSize(
        this.modalName,
        this.modalSize,
      );
      this.modalWidth =
        typeof size.width === 'number' ? `${size.width}px` : size.width;
      this.modalHeight =
        typeof size.height === 'number' ? `${size.height}px` : size.height;
    },

    /**
     * Handle window resize - adjust modal if on mobile
     */
    handleWindowResize() {
      if (modalResizeUtils.isMobile()) {
        this.modalWidth = '100%';
        this.modalHeight = '100%';
      } else {
        // Reload stored or default size on desktop
        this.initModalSize();
      }
    },

    /**
     * Handle modal resize from resize handle
     */
    handleModalResize({ width, height }) {
      if (modalResizeUtils.isMobile()) {
        return; // Don't resize on mobile
      }

      const constrained = modalResizeUtils.constrainSize(width, height);
      this.modalWidth = `${constrained.width}px`;
      this.modalHeight = `${constrained.height}px`;
    },

    /**
     * Handle resize end - save to localStorage
     */
    handleResizeEnd() {
      if (!this.modalName || modalResizeUtils.isMobile()) {
        return;
      }

      // Parse current dimensions
      const width = parseFloat(this.modalWidth);
      const height = parseFloat(this.modalHeight);

      if (!isNaN(width) && !isNaN(height)) {
        modalResizeUtils.saveSize(this.modalName, width, height);
      }
    },

    /**
     * Reset modal size to defaults
     */
    resetModalSize() {
      if (!this.modalName) {
        return;
      }

      modalResizeUtils.resetSize(this.modalName);
      this.initModalSize();
    },
  },
};
